import { businessKey } from 'queryKeys';

export const IO = 'IO';
const ioQuery = businessKey.query(IO);

export const grids = ioQuery.grids();
export const grid = ioQuery.grid();

export const details = ioQuery.details();
export const model = ioQuery.exact();

export const reasons = ioQuery.exact();

export const mutations = ioQuery.mutations();

const MORE_INFO = 'moreInfo';
const TERMINATE = 'terminate';
const MARK_AS_SIGNED = 'markAsSigned';
const MARK_AS_AGREEMENT = 'markAsAgreement';
const RESEND_IO = 'resendIO';

export const create = mutations.create();
export const update = mutations.update();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const remove = mutations.delete();
export const undo = mutations.undo();
export const addComment = mutations.addComment();
export const moreInfo = mutations.mutate(MORE_INFO);
export const terminate = mutations.mutate(TERMINATE);
export const markAsSigned = mutations.mutate(MARK_AS_SIGNED);
export const markAsAgreement = mutations.mutate(MARK_AS_AGREEMENT);
export const resendToIOPartner = mutations.mutate(RESEND_IO);
